import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MATERIAL_THUMBNAIL_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "kravet" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
    },
}

const MATERIAL_THUMBNAIL_TYPE_ = MATERIAL_THUMBNAIL_TYPE.filter((type) => type !== DataObjectAssignmentType.MaterialThumbnail_10x10)

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_ARTICLE_ID$",
    },

    // thumbnails
    ...MATERIAL_THUMBNAIL_TYPE_.map((type) => ({
        type,
        schema: "$MATERIAL_ARTICLE_ID$.$IMAGE_FORMAT$",
        options,
    })),

    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "$MATERIAL_ARTICLE_ID$_2.$IMAGE_FORMAT$",
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_ARTICLE_ID$_4.$IMAGE_FORMAT$",
    },
]
